import { s as script } from './Checkbox-5060fa51.mjs';
export { s as OCheckbox } from './Checkbox-5060fa51.mjs';
import { b as registerComponent } from './plugins-0d853d1f.mjs';
import 'vue';
import './CheckRadioMixin-f5b57344.mjs';
import './config.mjs';
import './helpers.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export { index as default };
